// Imports
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import Notice from '../notice';


// Styled components
const Bar = styled(Notice)`
	padding: 1rem;
	border-radius: 0;
	
	&:not(:last-child) {
		margin-bottom: 0;
	}
`;

const Text = styled.p`
	max-width: 62.5rem;
	margin: 0 auto;
	text-align: center;
`;


// Function component
const NonMemberNotice: React.FC = () => (
	<Bar color='yellow'>
		<Text>
			You’re signed in, but not a member of this community website. Join by{' '}
			<Link to='/account/register'>registering here</Link>.
		</Text>
	</Bar>
);

export default NonMemberNotice;
